/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/30
 */
import React from 'react';

const Next = () => {
  return <svg viewBox="0 0 1024 1024" className="store-svg-next">
    <path d="M786.985168 470.032787L316.952381 15.98751c-22.382514-22.382514-57.555035-22.382514-83.135051 0-22.382514 22.382514-22.382514 57.555035 0 79.937549l428.465262 412.477751L237.014832 927.275566c-22.382514 22.382514-22.382514 57.555035 0 79.937549s57.555035 22.382514 83.135051 0l466.835285-454.045277c25.580016-25.580016 25.580016-60.752537 0-83.135051z"/>
  </svg>
};

export default Next;



// WEBPACK FOOTER //
// ./src/svgs/next.js